<script setup lang="ts">
import { cloneDeep } from 'lodash'
import { computed } from 'vue'

import {
  BlockPointAttribute,
  TeamSide,
} from '@collector/sportsapi-client-legacy'
import { useIncidentGroupComponents } from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/composables/useIncidentGroupComponents'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import FieldZonesModal from '../components/FieldZonesModal/FieldZonesModal.vue'
import { filterAttributesBasedOnSelectedZone } from '../components/FieldZonesModal/utils'
import { zones } from './consts'

interface Props {
  linkedIncident: ProbableLinkedIncident
}
const props = defineProps<Props>()

// composables
const localLinkedIncident = cloneDeep(props.linkedIncident)
const incidentGroupComponentsComposable = useIncidentGroupComponents(
  localLinkedIncident,
  new Map(),
)
const { updateIncident: _updateIncident, selectedAttributes } =
  incidentGroupComponentsComposable

// computed
const incidentParticipantTeamSide = computed(() => {
  return props.linkedIncident.side === TeamSide.Home
    ? TeamSide.Away
    : TeamSide.Home
})

// emits
const emit = defineEmits(['close'])

// methods
function updateIncident(data: { selectedZone: number | null }): void {
  const attributes = filterAttributesBasedOnSelectedZone(
    selectedAttributes.value as BlockPointAttribute[],
    zones,
    data.selectedZone,
  )

  _updateIncident({
    attribute_ids: attributes,
  })

  emit('close')
}
</script>

<template>
  <FieldZonesModal
    :linkedIncident
    :zones
    :incidentParticipantTeamSide
    @save="updateIncident"
    @close="$emit('close')"
  />
</template>
